// Brand colors
export const COLOR_GREEN = '#83c021';
export const COLOR_GREEN_HOVER = '#6fa017';
export const COLOR_BROWN_PRIMARY = '#4B2E39';
export const COLOR_BROWN_SECONDARY = '#775562';

// UI colors
export const COLOR_TOPBAR = '#334047';
export const COLOR_STEP_PANEL_BG = '#FEFEFF';
export const COLOR_PRICE_CARD_BG = '#FDFDFD';
export const COLOR_MENU_TEXT = '#5E686B';
export const COLOR_STEPPER_INACTIVE_TEXT = '#99A2A9';
export const COLOR_STEPPER_INACTIVE_BG = '#DEE7EC';
export const COLOR_SECONDARY_BUTTON = '#757575';
export const COLOR_NEUTRAL_BUTTON_ACTIVE = '#424242';
export const COLOR_FOOTER_BG = '#333';
export const COLOR_FOOTER_LINK = '#3399FF';

// Gradients
export const GRADIENT_RAINBOW =
	'linear-gradient(90deg, #ff7b00, #ff2d55, #b027ff, #2db2ff)';
export const GRADIENT_RAINBOW_FADED =
	'linear-gradient(90deg, rgba(255,123,0,.6), rgba(255,45,85,.6), rgba(176,39,255,.6), rgba(45,178,255,.6))';
export const GRADIENT_WARM = 'linear-gradient(90deg, #FF7E5F, #FEB47B)';
export const GRADIENT_HERO_BG =
	'linear-gradient(180deg, rgba(255,245,225,1) 20%, rgba(201,216,197,1) 80%)';
export const GRADIENT_STEPPER_ACTIVE =
	'linear-gradient(135deg, #ee0979, #ff6a00)';
export const GRADIENT_LIBRARY_INFO_BG =
	'linear-gradient(180deg, #fffaf3 0%, #f7fdf8 100%)';

// Dividers
export const COLOR_DIVIDER = '#e0e0e0';

// Shadows
export const SHADOW_IMAGE_CARD = '5px 5px 20px 0px rgba(0,0,0,0.5)';
export const SHADOW_MODAL = '0 12px 40px rgba(0,0,0,0.6)';
export const SHADOW_CARD_SUBTLE = '0 3px 14px rgba(0,0,0,0.06)';

// Border radii
export const RADIUS_SM = '8px'; // cards, chips
export const RADIUS_MD = '12px'; // modals, content panels
export const RADIUS_LG = '15px'; // wizard step panels

// Account drawer
export const COLOR_DRAWER_HEADER_BG = 'rgba(0,0,0,0.2)';
export const COLOR_DRAWER_BORDER = 'rgba(255,255,255,0.08)';
export const COLOR_DRAWER_ITEM_TEXT = 'rgba(255,255,255,0.9)';
export const COLOR_DRAWER_ITEM_HOVER = 'rgba(255,255,255,0.07)';
export const COLOR_DRAWER_ICON_LOADING = 'rgba(255,255,255,0.5)';
export const COLOR_DRAWER_ICON_MY_PATTERNS = '#64b5f6';
export const COLOR_DRAWER_ICON_PATTERN_LIBRARY = '#81c784';
export const COLOR_DRAWER_ICON_PATTERN_MAKER = '#b39ddb';
export const COLOR_DRAWER_ICON_MANAGE_ACCOUNT = '#ffb74d';
export const COLOR_DRAWER_ICON_PASSWORD_RESET = '#f48fb1';
export const COLOR_DRAWER_ICON_CONTACT = '#80deea';
export const COLOR_DRAWER_ICON_LOGOUT = '#ef9a9a';
export const COLOR_DRAWER_ICON_COMMUNITY = '#4fc3f7';

// Misc
export const COLOR_PURPLE_LINK = '#b027ff';
export const COLOR_ICON_INACTIVE = '#ccc';
